import { BuiedPointClick_Fn } from "../../../../../assets/js/BuriedPointEvent";
export default {
    name: 'popup',
    data() {
        return {
            showpup: false,
        }
    },
    props: ['showpopup', 'answer'],
    mounted() {
    },
    methods: {
        ToHistory() {
            // 点击每日辟谣历史页埋点
            BuiedPointClick_Fn("milkinfo_home_clarifyrumors_click", {
                click_button: "查看以往问题",
            });
            setTimeout(() => {
                this.$router.push({ name: 'historylist' })//每日辟谣历史页
            }, 300);
        },
        // 换算百分比
        num(F, T) {
            console.log(F, T, 'F,T')
            return F / (F + T) * 100 + '%'
        }
    }

}